import { useDispatch, useSelector } from 'react-redux';
/// React router dom
import { Link } from 'react-router-dom';
import { navtoggle } from '../../../store/actions/AuthActions';

/// images
import logo from '../../../images/medsky_logo.png';
// import logoText from "../../../images/logo-text.png";

const NavHader = () => {
  // const [toggle, setToggle] = useState(false);
  const dispatch = useDispatch();
  const sideMenu = useSelector((state) => state.sideMenu);
  const handleToogle = () => {
    dispatch(navtoggle());
  };
  return (
    <div className="nav-header">
      <Link to="/dashboard" className="brand-logo">
        <img className="logo-abbr me-4" src={logo} alt="" />
        {!sideMenu && (
          <span className="d-none d-lg-inline fs-3 fw-bold text-dark ">
            Medsky <span className="text-primary">AMC</span>
          </span>
        )}
      </Link>

      <div
        className="nav-control"
        onClick={() => {
          handleToogle();
        }}
      >
        <div className={`hamburger ${sideMenu ? 'is-active' : ''}`}>
          <span className="line"></span>
          <span className="line"></span>
          <span className="line"></span>
        </div>
      </div>
    </div>
  );
};

export default NavHader;
